import { parseNumber } from '../../utils/number.utils';
import { HistoricalMovements } from '../historical-movements';
import { HistoricalMovementBuilder } from './historical-movement.builder';

export class HistoricalMovementsBuilder {
  static fromJson(json) {
    return (json)
      ? new HistoricalMovements(
        HistoricalMovementBuilder.fromList(json.historicalMovements),
        parseNumber(json.totalPage),
        parseNumber(json.total)
      )
      : null;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/historical-movements.builder.ts